import React, { useState, useEffect, useRef } from 'react'

import { functions, isEqual, omit } from 'lodash'

const GM_API_SRC = `${process.env.REACT_APP_GOOGLE_MAPS_API_URL}?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`

export const GoogleMap = ({ options, onMount, onMountProps, className, children, containerHeight='835px' }) => {
  const [ googleMap, setGoogleMap ] = useState()
  const [ autocomplete, setAutocomplete ] = useState()
  const [ geocoder, setGeocoder ] = useState()

  const maps = useRef()

  useEffect(() => {
    // The Google Maps API modifies the options object passed to
    // the Map constructor in place by adding a mapTypeId with default
    // value 'roadmap'. { ...options } prevents this by creating a copy.
    const onLoad = () => {
      setGoogleMap(new window.google.maps.Map(maps.current, { ...options }))
      setAutocomplete(new window.google.maps.places.AutocompleteService())
      setGeocoder(new window.google.maps.Geocoder())
    }

    if (!window.google) {
      const script = document.createElement(`script`)
      script.src = GM_API_SRC
      script.async = true
      script.defer = true
      document.head.append(script)
      script.addEventListener(`load`, onLoad)

      return () => script.removeEventListener(`load`, onLoad)
    } else {
      onLoad()
    }
  }, [ options ])

  useEffect(() => {
    if (googleMap && typeof onMount === `function`) {
      onMount(googleMap, autocomplete, geocoder, onMountProps)
    }
  }, [googleMap, geocoder, onMount, autocomplete, onMountProps])


  return (
    <div ref={maps} style={{ height: containerHeight }} {...{ className }} />
  )
}

const shouldNotUpdate = (props, nextProps) => {
  const [ funcs, nextFuncs ] = [ functions(props), functions(nextProps) ]

  const noPropChange = isEqual(omit(props, funcs), omit(nextProps, nextFuncs))
  const noFuncChange =
    funcs.length === nextFuncs.length &&
    funcs.every(fn => props[fn].toString() === nextProps[fn].toString())

  return noPropChange && noFuncChange
}

GoogleMap.defaultProps = {
  options: {
    center: {
      lat: 43.035338, // Roughly Syracuse, NY
      lng: -76.2093206,
    },
    zoom: 7,
  },
}

export default React.memo(GoogleMap, shouldNotUpdate)
